import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { categoriasService } from "@/modules/biblioteca/services/categoriasService";

const QUERY_KEY_CATEGORIAS = ["categorias"];

export function useCategorias() {
  return useQuery({
    queryKey: QUERY_KEY_CATEGORIAS,
    queryFn: categoriasService.listarTodas,
  });
}

export function useCriarCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (nome: string) => categoriasService.criar(nome),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_CATEGORIAS }),
  });
}

/** Usado apenas no FormularioLivro (inline): retorna existente se já houver. */
export function useCriarOuBuscarCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (nome: string) => categoriasService.criarOuBuscarExistente(nome),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_CATEGORIAS }),
  });
}

export function useAtualizarCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, nome }: { id: string; nome: string }) =>
      categoriasService.atualizar(id, nome),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_CATEGORIAS });
      // Nomes de categoria mudam o que aparece em GerenciarLivros (categoria_nome).
      queryClient.invalidateQueries({ queryKey: ["livros"] });
    },
  });
}

export function useExcluirCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => categoriasService.excluir(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_CATEGORIAS }),
  });
}
